import { useAdminContext } from "./admin-provider";

export function useIsAdmin() {
  const { isAdmin } = useAdminContext();
  return isAdmin;
}
